module.exports = __webpack_public_path__ + "img/01.63e450c1.jpg";